export default __webpack_public_path__ + "static/media/plat-ben3.71b87cd8.svg";